module.exports = __webpack_public_path__ + "images/emoji/moneybag.a0feadf251913ad71d83.png";